import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { NbThemeModule } from "@nebular/theme";

import { NbSecurityModule } from "@nebular/security";
import {
  LineTruncationDirective,
  LineTruncationLibModule,
} from "./modules/line-truncation/line-truncation.module";

// import {} from "./components";

import { NbEvaIconsModule } from "@nebular/eva-icons";
import { HeadingComponent } from "./components";
import { ngVideoDirective } from "./directives";
import { SanitizeHtmlPipe } from "./pipes";
import { DateFormatPipe } from "./pipes/date-format.pipe";
import { TruncateObjectPipe } from "./pipes/truncateobject.pipe";
import { DEFAULT_THEME } from "./styles/theme.default";

const NB_MODULES = [NbEvaIconsModule, NbSecurityModule, ngVideoDirective];

const COMPONENTS = [HeadingComponent];

const STANDALONE_PIPES = [TruncateObjectPipe, DateFormatPipe, SanitizeHtmlPipe];

@NgModule({
  imports: [
    CommonModule,
    ...NB_MODULES,
    ...COMPONENTS,
    ...STANDALONE_PIPES,
    LineTruncationLibModule,
  ],
  exports: [CommonModule, ...COMPONENTS, LineTruncationDirective],
  declarations: [],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: "mirasee",
          },
          [DEFAULT_THEME]
        ).providers,
      ],
    };
  }
}
